import { combineReducers } from 'redux'
import { ActionTypes } from '../constants'
import { connectRouter } from 'connected-react-router'
import _ from 'lodash'
import session from './session'
import students from './students'
import parents from './parents'
import teachers from './teachers'
import profile from './profile'
import api from './api'

const global = (state = {
  examples: [],
  languages: [],
  locale: 'en',
  domainLanguages: [],
  olympiads: [],
  event: {}
}, action) => {
  switch (action.type) {
  case ActionTypes.CHANGE_LOCALE:
    return { ...state, locale: action.locale }

  case ActionTypes.STATE_FETCHING_SUCCESS:
    if (_.isEqual(state.event, action.event)) { return state }
    return { ...state, event: action.event }

  default:
    return state
  }
}

export default (history) => combineReducers({
  router: connectRouter(history),
  session,
  students,
  parents,
  teachers,
  profile,
  api,
  global
})
